<template>
  <div>
    <div class="monitor container is-fluid">
      <div class="columns">
        <div class="column is-8">
          <h4 class="is-size-4-desktop">Descarga de recuentos</h4>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-table
            :narrowed="true"
            :bordered="true"
            :data="recuentos"
            :paginated="true"
            :per-page="tamanoPagina"
            :current-page.sync="paginaActual"
            :pagination-simple="false"
            :loading="isLoading"
            pagination-position="bottom"
            default-sort="user.id"
            aria-next-label="Siguiente página"
            aria-previous-label="Página anterior"
            aria-page-label="Página"
            aria-current-label="Página actual"
          >
            <b-table-column
              v-slot="props"
              field="id"
              label="Doc Number"
              width="10%"
              class="has-text-centered"
            >
              {{ props.row.documentNumber }}
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="id"
              label="Fecha Creación"
              width="12%"
              class="has-text-centered"
            >
              {{
                format(parseISO(props.row.fechaCreacion), 'dd/MM/yyyy HH:mm')
              }}
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="motivo"
              label="Motivo"
              width="240"
            >
              <span>
                {{ props.row.motivo }}
              </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="comentario"
              label="Comentario"
              width="240"
            >
              <span>
                {{ props.row.comentario }}
              </span>
            </b-table-column>
            <b-table-column
              v-slot="props"
              field="estado"
              label="Estado"
              width="8%"
            >
              <span>
                {{ props.row.estado }}
              </span>
            </b-table-column>
            <b-table-column v-slot="props" label="Acciones" width="7%">
              <b-button
                type="is-info"
                size="is-small"
                title="Descargar Recuento"
                @click="descargarRecuento(props.row.id)"
              >
                <b-icon icon="download" />
              </b-button>
            </b-table-column>
            <template slot="empty">
              <div class="content has-text-grey has-text-centered">
                <p>No hay registros.</p>
              </div>
            </template>
          </b-table>
        </div>
      </div>
      <div class="columns">
        <div class="column is-12">
          <b-button
            type="is-info"
            :disabled="isLoading"
            icon-left="sync-alt"
            @click="getRecuentos()"
          >
            Actualizar
          </b-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { format, parseISO } from 'date-fns'

import { inventarioService } from '@/services'

export default {
  name: 'Descargas',
  data() {
    return {
      recuentos: [],
      paginaActual: 1,
      tamanoPagina: 10,
      isLoading: false,
      format,
      parseISO
    }
  },
  mounted() {
    this.getRecuentos()
  },
  methods: {
    async descargarRecuento(id) {
      const self = this
      self.isLoading = true
      await inventarioService
        .downloadRecuento(id)
        .then((response) => {
          this.notificarAccionCompletada(
            'Se agregó el recuento indicado correctamente.'
          )
          this.$router.push(
            `/inventario/recuentos?ids=${response.data.join(',')}`
          )
        })
        .catch((error) => this.procesarError(error))
        .then(() => (self.isLoading = false))
    },
    async getRecuentos() {
      const self = this
      self.isLoading = true
      await inventarioService
        .getRecuentosNuevos()
        .then((response) => (self.recuentos = response.data))
        .catch((error) => this.procesarError(error))
        .then(() => (self.isLoading = false))
    }
  }
}
</script>
